module.exports = __webpack_public_path__ + "img/teambuilding1.d9cff254.jpg";